import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.posts');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ensureAuthenticated } from 'src/app/shared/auth';

@Component({
    selector: 'wiz-page-posts',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.posts/view.scss */
/* src/app/page.posts/view.scss: no such file or directory */`],
})
export class PagePostsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!(await ensureAuthenticated())) {
            location.replace('/access');
        }
    }
}

export default PagePostsComponent;